import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../apiEcommerce";

export const submitOrder = createAsyncThunk(
  "submitOrder/submitOrder",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/payment/pay`,
        orderData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error submit order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to submit order"
      );
    }
  }
);

const submitOrderSlice = createSlice({
  name: "submitOrder",
  initialState: {
    orderData: {
      eco_order_id: "",
      type: "",
      device: "web",
    },
    status: "idle",
    error: null,
    response: null,
  },
  reducers: {
    setOrderField: (state, action) => {
      const { field, value } = action.payload;
      state.orderData[field] = value;
    },
    setOrderData: (state, action) => {
      state.orderData = { ...state.orderData, ...action.payload };
    },
    resetOrderData: (state) => {
      state.orderData = {
        eco_order_id: "",
        type: "",
        device: "web",
      };
      state.status = "idle";
      state.error = null;
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitOrder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(submitOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.response = action.payload;
      })
      .addCase(submitOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setOrderField, setOrderData, resetOrderData } =
  submitOrderSlice.actions;
export default submitOrderSlice.reducer;
